import type { MicroData } from '@/api/model/globalModel';
import qs from 'qs';
/**
 * router 兼容方法，与workbench
 * 1. name > appCode/pageCode
 * 2. path > /appCode/pageCode; ps: backend/before_proxy文件同步修改
 * */

export type MicroRouter = {
  appCode?: string;
  pageCode?: string;
  name?: string;
  path?: string;
};

export const getRouterName = ({
  appCode,
  pageCode,
  name,
}: MicroRouter): string => {
  if (appCode === 'carSource' && !pageCode) {
    return `carSource/car-source`;
  }
  if (appCode && pageCode) {
    return `${appCode}/${pageCode}`;
  } else {
    return name || appCode || '';
  }
};

export const getRouterPath = ({
  appCode,
  pageCode,
  name,
  microType,
}: MicroData) => {
  let resultPath = '';
  if (appCode && pageCode) {
    resultPath = `/${appCode}/${pageCode}`;
  } else {
    /*这里需要确认下link的情况*/
    resultPath = `/${appCode}` || `/${name}`;
  }
  if (microType === 'dashboard') {
    resultPath = `/dashboard${resultPath}`;
  }
  return resultPath;
};

export const validateHash = (lHash: string, rHash: string) => {
  if (lHash === rHash) {
    return true;
  } else if (!!lHash && !!rHash) {
    if (
      (lHash[0] === '#' && lHash.substr(1) === rHash) ||
      (rHash[0] === '#' && rHash.substr(1) === lHash)
    ) {
      return true;
    }
  }
  return false;
};

export const getTitMicroId = (
  path: string = '',
  isMainEntry: boolean = false
) => {
  return (isMainEntry ? '' : Date.now()) + path.replace(/[\W]/g, '');
};

export const getAdministratorArr = (list: any[], identifier: string): any => {
  if (list) {
    const data = list.find((item) => item.identifier === identifier);
    if (data) {
      const arr = (data.children || []).map((item: any) => item.identifier);
      return [...arr, data.identifier];
    }
    for (const item of list) {
      return getAdministratorArr(item.children || [], identifier);
    }
  }
  return null;
};

export const getUrlParam = (str: string, url?: string) => {
  const re = new RegExp('(^|\\?|&)' + str + '=([^&^#]+)(&|$|#)', 'i');
  url = url || window.location.href;
  const m = url.match(re);
  if (m) {
    return m[2];
  }
  return '';
};

export const getObjectToUrl = (paramObj: any, beforeStr: string) => {
  if (!paramObj) {
    return '';
  }
  let paramList: any[] = [];
  const keyArr = Object.keys(paramObj);
  keyArr &&
    keyArr.forEach((key) => {
      let val = paramObj[key] || '';
      if (val.constructor === Array) {
        val.forEach((_val) => {
          paramList.push(key + '=' + _val);
        });
      } else {
        paramList.push(key + '=' + val);
      }
    });
  const str = paramList.join('&');
  return (str ? beforeStr || '' : '') + str;
};

export const getMergePath = (arr: any = [], query?: Record<string, string>) => {
  const path = '/' + arr.filter((val: string) => !!val).join('/');
  if (query) {
    return path + '?' + qs.stringify(query);
  }
  return path;
};

export const formatMicroData = (data: MicroData) => {
  const replaceData: any = {
    //im: 'http://127.0.0.1:7088'
  };
  // data.serveBrand = data.serveBrand || ['nio'];
  // data.serveBrand = ['nio'];
  data.crossBrandType = data.crossBrandType ? data.crossBrandType : 'mix';
  if (!data.serveBrand && data.crossBrandType === 'mix') {
    data.serveBrand = ['nio', 'alps'];
  }
  const format = (brand = 'nio') => {
    const brandAppCode =
      brand === 'nio' ? data.appCode : `${data.appCode}-${brand}`;
    const formatted: MicroData = {
      ...data,
      errorCount: 0,
      appCode: brandAppCode,
      group: 'more',
      name: getRouterName({
        ...data,
        appCode: brandAppCode,
      }),
      path: getRouterPath({
        ...data,
        appCode: brandAppCode,
      }),
      initialHash: data.hash,
      entry: replaceData[data?.name] || data.entry,
      crossBrandType: data.crossBrandType || 'mix',
    };
    const fullPath = `${formatted.path}${formatted.hash}`;
    formatted.fullPath = fullPath;
    return formatted;
  };
  // return data.serveBrand.map();

  return data.crossBrandType === 'mix'
    ? [format('nio')]
    : data.serveBrand?.map(format) || [];
};

export const getFullPathFromLocation = () => {
  return window.location.href.replace(
    `${window.location.protocol}//${window.location.host}`,
    ''
  );
};
